import { COLORS } from 'ethos-design-system'

import Markdown, {
  MARKDOWN_NODE_RESTRICTION_SETS,
} from '../../../global/Markdown'

export const H1Responsive = ({
  color,
  copy,
  className,
  useNewFonts,
}: {
  color?: COLORS
  copy: string
  className?: string
  useNewFonts?: boolean
}): JSX.Element => (
  <div className={className}>
    <div className="sm:block lg:hidden" suppressHydrationWarning>
      <h1
        className={useNewFonts ? 'new-display-m' : 'old-title-large-500'}
        style={{
          color: `var(--${color})`,
          lineHeight: '130%',
          fontSize: '32px',
        }}
      >
        <Markdown
          input={copy}
          allowedMarkdownTypes={MARKDOWN_NODE_RESTRICTION_SETS.LINK_ONLY}
        ></Markdown>
      </h1>
    </div>
    <div className="hidden lg:block" suppressHydrationWarning>
      <h1
        className={useNewFonts ? 'new-display-l' : 'old-title2-xlarge-500'}
        style={{
          color: `var(--${color})`,
          fontSize: '60px',
          lineHeight: '110%',
        }}
      >
        <Markdown
          input={copy}
          allowedMarkdownTypes={MARKDOWN_NODE_RESTRICTION_SETS.LINK_ONLY}
        ></Markdown>
      </h1>
    </div>
  </div>
)
